import React from "react";
import { ParticleBackground } from "@/components/ParticleBackground";

export function DarkChapter({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative">
      {/* Unified dark background with all layers */}
      <div className="absolute inset-0 z-0">
        {/* Dark base with grid pattern */}
        <div className="absolute inset-0 bg-bg-0 grid-pattern" />
        
        {/* Radial gradient for text readability */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_1200px_900px_at_20%_50%,rgba(0,0,0,0.85)_0%,transparent_65%)] z-[2]" />
        
        {/* Gradient overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80 z-[3]" />
        
        {/* Particle background with fade */}
        <div className="absolute inset-0 z-[3]">
          <div
            className="absolute inset-0"
            style={{
              maskImage: "linear-gradient(to bottom, black 0%, black 30%, transparent 85%)",
              WebkitMaskImage: "linear-gradient(to bottom, black 0%, black 30%, transparent 85%)",
            }}
          >
            <ParticleBackground />
          </div>
        </div>
      </div>
      
      {/* Content on top */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
